import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { BasicLineDefinition, SnappingLevel } from '../slices/applicationSlice';

interface NotInsertingBasicInsertionInformation {
  readonly inserting: false;
}

export interface InProgressBasicInsertionInformation {
  readonly inserting: 'member' | 'referenceLine';
  readonly definition: BasicLineDefinition;

  // currently only matters for parallel line snapping
  readonly snappingLevel: SnappingLevel;
}

export type BasicInsertionInformation = NotInsertingBasicInsertionInformation | InProgressBasicInsertionInformation;

const NOT_INSERTING: NotInsertingBasicInsertionInformation = Object.freeze({ inserting: false });

export function isBasicInsertionModeActive(
  info: BasicInsertionInformation,
): info is InProgressBasicInsertionInformation {
  return !!info.inserting;
}

export const getBasicInsertionInformation = createSelector(
  (state: RootState) => state.application.insertingObjectInfo,
  (state: RootState) => state.application.snappingLevel,
  (insertingObjectInfo, snappingLevel): BasicInsertionInformation => {
    if (insertingObjectInfo?.type !== 'member' && insertingObjectInfo?.type !== 'referenceLine') {
      return NOT_INSERTING;
    }

    return {
      inserting: insertingObjectInfo.type,
      definition: insertingObjectInfo.basicDefinition,
      snappingLevel,
    };
  },
);
